

















































































import { Component, Vue, Prop } from "vue-property-decorator";
import { RouterService, RouteInfo } from "@/shared/services/router-service";

interface RouteItem {
  text: string;
  value: string;
}

@Component
export default class RouteSelector extends Vue {
  @Prop({ default: "" }) value!: string;
  @Prop({ default: "Ruta" }) label!: string;

  public search: string = "";
  public menuOpen: boolean = false;

  get routeItems(): RouteItem[] {
    const routes = RouterService.getAllRoutes();

    return routes.map((route: RouteInfo) => ({
      text: RouterService.formatRouteName(route.name),
      value: route.fullPath,
    }));
  }

  get filteredRoutes(): RouteItem[] {
    if (!this.search) return this.routeItems;

    const searchLower = this.search.toLowerCase();
    return this.routeItems.filter(
      (item) =>
        item.text.toLowerCase().includes(searchLower) ||
        item.value.toLowerCase().includes(searchLower)
    );
  }

  public selectRoute(value: string) {
    this.$emit("input", value);
    this.menuOpen = false;
  }

  public onManualInput(value: string) {
    this.$emit("input", value);
  }
}
